import React, { Component, Fragment } from 'react'
import firebase from '../../modules/Firebase'
import AppTableRows from '../../components/AppTableRows'
import BuildUploader from '../../components/BuildUploader'
import Modal from '../../components/Modal'
import {
  Table,
  Button,
  Grid,
  Row,
  Col,
} from 'react-bootstrap'

class Builds extends Component {
  state = {
    builds: {},
    modalVisible: false,
  }

  componentDidMount() {
    const buildsRef = firebase.database().ref('builds')
    buildsRef.on('value', (snapshot) => {
      this.setState({
        builds: snapshot.val() || {}
      })
    })
  }

  updateBuilds = ({
    platform,
    environment,
    url: packageUrl,
    fileName,
    version
  }) => {
    const newBuildKey = firebase.database().ref(`builds/${platform}`).push().key
    firebase.database().ref(`builds/${platform}/${newBuildKey}`).set({
      environment,
      packageUrl,
      version,
      fileName
    })
    if (this.state.modalVisible) {
      this.setState({
        modalVisible: false,
      })
    }
  }

  deleteBuild = (key, platform) => {
    const platformBuilds = this.state.builds[platform]
    const buildToBeRemoved = platformBuilds[key]
    this.removeBuildFromStorage(buildToBeRemoved)
      .then(() => {
        firebase.database().ref(`builds/${platform}/${key}`).remove()
      })
  }

  removeBuildFromStorage = ({ fileName }) => {
    const storageRef = firebase.storage().ref()
    const buildRef = storageRef.child(`builds/${fileName}`)
    return buildRef.delete()
  }

  toggleModal = () => {
    this.setState({
      modalVisible: this.state.modalVisible ? false : true,
    })
  }

  render() {
    const { builds, modalVisible } = this.state
    const buildKeys = Object.keys(builds)
    return (
      <Fragment>
        <Grid>
          <Row className="show-grid">
            <Col md={12}>
              <h3>Builds</h3>
              <Table bordered hover>
              {
                buildKeys.map((key, i) => (
                  <Fragment key={key + i}>
                    <thead>
                        <tr>
                          <th colSpan="12">
                            <img src={`images/${key.toLowerCase()}.png`} alt={`${key}`} />
                          </th>
                        </tr>
                    </thead>
                    <tbody>
                      <AppTableRows releases={builds[key]} canDelete onDelete={(key) => this.deleteBuild(key, key)} />
                    </tbody>
                  </Fragment>
                ))
              }
              </Table>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <Button bsStyle="primary" onClick={this.toggleModal}>Upload Build</Button>
            </Col>
          </Row>
        </Grid>
        <Modal title="Upload Build" show={modalVisible} onClose={this.toggleModal}>
          <BuildUploader onUploadSuccess={this.updateBuilds} />
        </Modal>
      </Fragment>
    )
  }
}

export default Builds


// WEBPACK FOOTER //
// ./src/routes/builds/index.js